import { render, staticRenderFns } from "./InsurancePage.vue?vue&type=template&id=4816c1bd"
import script from "./InsurancePage.vue?vue&type=script&lang=js"
export * from "./InsurancePage.vue?vue&type=script&lang=js"
import style0 from "./InsurancePage.vue?vue&type=style&index=0&id=4816c1bd&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports